import { CommonsService } from "./../../../services/commons/commons.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Component, OnInit, ViewChild, ViewContainerRef } from "@angular/core";
import { ModalController, AlertController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { RecorteService } from "src/app/services/recorte/recorte.service";

import * as moment from "moment";
import * as textMask from "vanilla-text-mask/dist/vanillaTextMask.js";
import { IonicSelectableComponent } from "ionic-selectable";

@Component({
  selector: "app-search-filter",
  templateUrl: "./search-filter.page.html",
  styleUrls: ["./search-filter.page.scss"]
})
export class SearchFilterPage implements OnInit {
  mask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
  maskedInputController;

  @ViewChild("input", { read: ViewContainerRef }) public input;
  @ViewChild("input2", { read: ViewContainerRef }) public input2;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.maskedInputController = textMask.maskInput({
        inputElement: this.input.element.nativeElement,
        mask: this.mask
      });

      this.maskedInputController = textMask.maskInput({
        inputElement: this.input2.element.nativeElement,
        mask: this.mask
      });
    });
  }

  ngOnDestroy() {
    this.maskedInputController.destroy();
    localStorage.removeItem("modalOpen");
    if (this.filtros == null) {
      this.recorteService.emitBuscaAvancada(null);
    }
  }
  public pesquisaAvancadaForm: FormGroup;

  selectedCaderno: any;
  filtros: any = "none";
  numeroProcesso;
  cadernos = [];
  @ViewChild("cadernosComponent") cadernoComponent: IonicSelectableComponent;

  constructor(
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private storage: Storage,
    private alertCtrl: AlertController,
    private recorteService: RecorteService,
    private commonsService: CommonsService
  ) {}

  selectClicado: boolean = true;

  public onOpen() {
    this.commonsService.closeLoading();
  }
  public carregarModalCadernos() {
    this.commonsService.showLoading("Carregando cadernos");
  }
  public clear() {
    this.cadernoComponent.clear();
    this.cadernoComponent.close();
  }

  public confirm() {
    this.cadernoComponent.confirm();
    this.cadernoComponent.close();
  }

  public clicouSelect() {
    this.selectClicado = true;
  }
  toggleItems() {
    this.cadernoComponent.toggleItems(
      this.cadernoComponent.itemsToConfirm.length ? false : true
    );

    // Confirm items and close Select page
    // without having the user to click Confirm button.
    // this.confirm();
  }

  /* public checkSelectClicado() {
    if (!this.selectClicado) {
      this.blurNgSelect();
    } else {
      this.selectClicado = false;
    }
  }
  public blurNgSelect() {
    let ngSelectInput: any = document.getElementsByClassName('ng-input');
    setTimeout(() => {
      ngSelectInput[0].children[0].blur();
    }, 100);
  } */
  maxDate;
  ngOnInit() {
    localStorage.setItem("modalOpen", "1");
    this.maxDate = new Date(2018, 5, 5);
    this.pesquisaAvancadaForm = this.formBuilder.group({
      caderno: [null, Validators.compose([Validators.required])],
      dataInicio: [
        moment(new Date()),
        Validators.compose([Validators.required])
      ],
      dataFim: [moment(new Date()), Validators.compose([Validators.required])],
      processo: []
    });
    const cadernos = JSON.parse(localStorage.getItem("cadernos"));
    this.cadernos = cadernos;
    let filtros: any;
    if (localStorage.getItem("filtros")) {
      filtros = JSON.parse(localStorage.getItem("filtros"));
    }
    if (filtros) {
      this.selectedCaderno = filtros.nCdCaderno;
      this.pesquisaAvancadaForm
        .get("dataInicio")
        .setValue(moment(filtros.tDtInicio));
      this.pesquisaAvancadaForm.get("dataFim").setValue(moment(filtros.tDtFim));
      if (filtros.sNrProcesso) this.numeroProcesso = filtros.sNrProcesso;
    }
  }
  async pesquisar() {
    if (this.pesquisaAvancadaForm.valid) {
      let dataInicioMoment = this.pesquisaAvancadaForm
        .get("dataInicio")
        .value.format();

      let dataFimMoment = this.pesquisaAvancadaForm
        .get("dataFim")
        .value.format();
      if (
        this.pesquisaAvancadaForm
          .get("dataFim")
          .value.diff(
            this.pesquisaAvancadaForm.get("dataInicio").value,
            "days",
            false
          ) > 30
      ) {
        const alert = await this.alertCtrl.create({
          header: "Atenção",
          message: "Intervalo maior que 30 dias.",
          buttons: ["OK"]
        });
        return await alert.present();
      } else if (
        this.pesquisaAvancadaForm.get("processo").value &&
        this.pesquisaAvancadaForm.get("processo").value.length < 5
      ) {
        const alert = await this.alertCtrl.create({
          header: "Atenção",
          message: "Número de processo deve ter ao menos 5 caracteres.",
          buttons: ["OK"]
        });
        return await alert.present();
      }
      let listaCodigoCadernos = this.pesquisaAvancadaForm
        .get("caderno")
        .value.map(a => a.nCdCaderno);

      let filtrosStorage = {
        nCdCaderno: this.pesquisaAvancadaForm.get("caderno").value,
        tDtInicio: this.pesquisaAvancadaForm.get("dataInicio").value.valueOf(),
        tDtFim: this.pesquisaAvancadaForm.get("dataFim").value.valueOf(),
        sNrProcesso: this.pesquisaAvancadaForm.get("processo").value
      };

      let filtro = {
        arrCdCaderno: listaCodigoCadernos,
        tDtInicio: dataInicioMoment.substring(0, dataInicioMoment.length - 6),
        tDtFim: dataFimMoment.substring(0, dataFimMoment.length - 6)
      };
      if (this.pesquisaAvancadaForm.get("processo").value) {
        filtro["sNrProcesso"] = this.pesquisaAvancadaForm
          .get("processo")
          .value.toString();
      }
      localStorage.setItem("filtros", JSON.stringify(filtrosStorage));
      this.filtros = filtro;
      this.recorteService.emitBuscaAvancada(filtro);
      this.closeModal();
    } else {
      if (
        (document.getElementById("inputDataInicio")["value"] &&
          !this.pesquisaAvancadaForm.get("dataInicio").value) ||
        (document.getElementById("inputDataFim")["value"] &&
          !this.pesquisaAvancadaForm.get("dataFim").value)
      ) {
        this.pesquisaAvancadaForm
          .get("dataInicio")
          .setValue(
            moment(
              document.getElementById("inputDataInicio")["value"],
              "DD/MM/YYYY"
            )
          );
        this.pesquisaAvancadaForm
          .get("dataFim")
          .setValue(
            moment(
              document.getElementById("inputDataFim")["value"],
              "DD/MM/YYYY"
            )
          );
        this.pesquisar();
      } else {
        const alert = await this.alertCtrl.create({
          header: "Atenção",
          message: "Caderno e datas de publicação são obrigatórios.",
          buttons: ["OK"]
        });
        return await alert.present();
      }
    }
  }

  async closeModal() {
    await this.modalCtrl.dismiss();
  }

  public limparFormulario() {
    this.pesquisaAvancadaForm.reset();
    localStorage.removeItem("filtros");
    this.filtros = null;
  }
}
